import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { MemberLight } from "src/app/backend/models/member/member";
import { ColorService } from "src/app/services/color.service";
import { MemberBootstrapCacheService } from "src/app/services/member-bootstrap-cache.service";

@Injectable()
export class ProvideColorsGuard {
  private readonly memberBootstrapCache = inject(MemberBootstrapCacheService);
  private readonly colorService = inject(ColorService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const members: MemberLight[] =
      await this.memberBootstrapCache.loadActiveAllLight();

    for (const member of members) {
      if (member.color) {
        this.colorService.register(member.id, member.color);
      }
    }

    return true;
  }
}
